import { DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import { CustomReportService } from "src/app/services/ReportService/CustomReport.service";
import { SnackBarService } from "src/app/services/SnackBar/SnackBarService.service";
import { tBillPayService } from "src/app/services/tBillPay.service";
import { AppSettings } from "src/app/shared/AppSettings";

@Component({
  selector: "app-payment-history-dialog",
  templateUrl: "./payment-history-dialog.component.html",
  styleUrls: ["./payment-history-dialog.component.css"],
})
export class PaymentHistoryDialogComponent implements OnInit {
  displayedColumns: string[] = [
    "invoiceNumber",
    "clthArrivalDateTime",
    "clthCaseDrID",
    "clthTherapistID",
    "diagnosis",
    "total",
    "itemTypeDiscount",
    "itemTypeConsultation",
    "itemTypePrescription",
    "itemTypePhysio",
    "itemTypeLab",
    "itemTypeXRay",
    "itemTypeProcedures",
    "itemTypeOthers",
    "outstanding",
    "prePay",
    "rePay",
    // "invoiceStatus"
  ];
  dataSource:PaymentHistoryModel[] = [];
  isLoading = true;

  @Input("patientID") patientID:string;
  @Input("patientName") patientName:string;

  constructor(
    public activeModal: NgbActiveModal,
    public datePipe: DatePipe,
    readonly translate: TranslateService,
    public billPayService:tBillPayService,
  ) {

  }

  ngOnInit() {
    this.getPaymentHistory();
  }

  getPaymentHistory(){
    this.billPayService.getPaymentHistory(this.patientID).subscribe(x=>{
      this.dataSource = x;
      this.isLoading = !this.isLoading;
    },err=>{
      console.error(err);
      this.isLoading = !this.isLoading;
    })
  }

  getFormatedDate(value:string|Date){
    return value ? this.datePipe.transform(value,AppSettings.dateFormat) : '';
  }
}
